import { Injectable } from '@angular/core';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Options for Facebook Pixel event tracking (deduplication with CAPI)
 */
export interface FacebookEventOptions {
  eventID?: string;
}

/**
 * Low-level wrapper around the Facebook Pixel (fbq).
 * Only responsible for firing browser-side pixel events.
 * Business logic and orchestration belong in AppEventsService.
 */
@Injectable({
  providedIn: 'root',
})
export class FacebookPixelService {
  /**
   * Track a standard Facebook Pixel event
   * @param eventName - Standard event name (e.g., 'Purchase', 'Lead')
   * @param params - Event parameters
   * @param options - Event options including eventID for deduplication with CAPI
   */
  trackEvent(
    eventName: string,
    params?: Record<string, unknown>,
    options?: FacebookEventOptions,
  ): void {
    if (typeof window !== 'undefined' && window.fbq) {
      if (params && options?.eventID) {
        window.fbq('track', eventName, params, { eventID: options.eventID });
      } else if (params) {
        window.fbq('track', eventName, params);
      } else {
        window.fbq('track', eventName);
      }

      console.log('[FB Pixel]', eventName, params, options);
    } else {
      console.log('[FB Pixel] Not sent (no fbq):', eventName, params, options);
    }
  }
}
